/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem } from '@insticator/insticator-ui';



/* ++++++++++ --------------- DETAILS TABLE : STYLES --------------- ++++++++++ */
export default {
	detailstable: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		'& .button': {
			fontWeight: 500,
			alignSelf: 'flex-end',
			height: pxToRem(36),
			padding: `${pxToRem(8)} ${pxToRem(16)}`,
			marginBottom: pxToRem(24),
			maxWidth: pxToRem(112),
			background: 'none',
			'& .fa-arrow-down': {
				fontSize: pxToRem(16)
			}
		},
    '& .exportlink': {
      alignSelf: 'flex-end',
      padding: `${pxToRem(8)} ${pxToRem(16)}`,
			marginBottom: pxToRem(24)
    }
	}
}; 